module.exports = __webpack_public_path__ + "img/treppenabgang.7f280a43.jpg";